import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms'; 
import { ActivatedRoute, Router } from '@angular/router'; 
import { ClientService } from '../_services/client.service';
import { TokenStorageService } from '../_services/token-storage.service';

@Component({
  selector: 'app-edit-client',
  templateUrl: './edit-client.component.html',
})
export class EditClientComponent implements OnInit {
  contactUUID: string = "";
  clientId: number = 0;
  contactTypeList: any = [];
  languageList: any = [];
  referralList: any = [];
  clientInfo: any = {};
  clientEmails: any = [];
  clientContactTypes: any = [];
  preappendtype: string = "";
  email_i: number = 0;
  update_message: string = "";
  curr_contact_type: number = 0;
  isForeman:boolean = false;
  userAccess:any;

  editClientForm: FormGroup = new FormGroup({
    first_name: new FormControl(""),
    last_name: new FormControl(""),
    gender: new FormControl(""),
    address: new FormControl(""),
    address2: new FormControl(""),
    city: new FormControl(""),
    province: new FormControl(""),
    country: new FormControl(""),
    postalcode: new FormControl(""),
    language: new FormControl(""),
    referral: new FormControl(""),
    referral_note: new FormControl("")
  })

  clientTypeForm: FormGroup = new FormGroup({});

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private tokenStorage: TokenStorageService,
    private client: ClientService,
  ) { }

  ngOnInit(): void {
    this.contactUUID = this.tokenStorage.getToken() || "";

    this.userAccess = this.tokenStorage.getUserAccess()|| "";
    console.log('this.userAccess clients', this.userAccess);
    if( this.userAccess == 4)
      this.isForeman = true;

    this.clientId = this.activatedRoute.snapshot.params['clientid'];
 
    this.client.getClientListContactTypes$(this.contactUUID)
      .subscribe((data: any) => {
        this.contactTypeList = data;

        data.sort(function (a:any, b:any) {
          return a.client_contact_type_id - b.client_contact_type_id;
        });

        this.clientContactTypes[1]= [];
        this.clientContactTypes[2]= [];
        this.clientContactTypes[3]= [];
        this.clientContactTypes[4]= [];
        this.clientContactTypes[5]= [];

        for(let i=0; i < data.length; i++) {
          if (data[i].client_contact_type_id == 4){
            this.clientTypeForm.addControl("contact_type_email"+i+"-" + data[i].client_contact_type_id, new FormControl(""));
          }else{
            this.clientTypeForm.addControl("contact_type_" + data[i].client_contact_type_id, new FormControl(""));
          }
        }
    });

    this.client.getClientListLanguages$(this.contactUUID)
      .subscribe((data: any) => {
        this.languageList = data;
    });

    this.client.getClientListReferrals$(this.contactUUID)
      .subscribe((data: any) => {
        this.referralList = data;
    });

    this.client.getClient$(this.contactUUID, this.clientId)
      .subscribe((data: {}) => {
        this.clientInfo = data;

        this.editClientForm.setValue({
          first_name: this.clientInfo.client_fname,
          last_name: this.clientInfo.client_lname,
          gender: this.clientInfo.client_gender,
          address: this.clientInfo.client_address,
          address2: this.clientInfo.client_address2,
          city: this.clientInfo.client_city,
          province: this.clientInfo.client_province,
          country: this.clientInfo.client_country,
          postalcode: this.clientInfo.client_postalcode,
          language: this.clientInfo.client_language_id,
          referral: this.clientInfo.client_referral_id,
          referral_note: this.clientInfo.client_referral_note,
        });

        console.log(this.clientInfo);

        for(let i=0; i < this.clientInfo.contacts.length; i++) {
          this.curr_contact_type = this.clientInfo.contacts[i].client_contact_type_id;
          //populate global contact type array
          this.clientContactTypes[this.curr_contact_type].push(this.clientInfo.contacts[i].value); 
         
          if (this.curr_contact_type == 4){
            this.clientEmails.push({address: this.clientInfo.contacts[i].value}); 
            this.email_i = this.clientEmails.length-1;
            this.preappendtype = "contact_type_email"+this.email_i+"-";
            let contactType = this.preappendtype + this.curr_contact_type;

            this.clientTypeForm.addControl(contactType, new FormControl(""));
            this.clientTypeForm.controls[contactType].patchValue(this.clientInfo.contacts[i].value);
          }else {
            this.preappendtype = "contact_type_";
            let contactType = this.preappendtype + this.curr_contact_type;
            this.clientTypeForm.controls[contactType].patchValue(this.clientInfo.contacts[i].value);
          }
        }
        //console.log('contact types initial: ', this.clientContactTypes);
    });
  }
  /*  Add an extra empty email field */
  addEmailClient(): void  {
      this.clientEmails.push({
          address: ''
      })
      const email_i=this.clientEmails.length-1;
      const preappendtype = "contact_type_email"+email_i+"-4";
      this.clientTypeForm.addControl(preappendtype, new FormControl(""));
  }

  onChangeEmail( index:number, fieldValue: any):void {
    this.clientEmails[index].address = fieldValue.value;
    console.log(this.clientEmails[index].address);
  }
  
  removeEmailClient(uId: number): void  {
    let potato = this.clientEmails.splice(uId, 1);
    const preappendtype = "contact_type_email"+uId+"-4";
    this.clientTypeForm.controls[preappendtype].patchValue("");
    //console.log(uId);
    //call remove client info here
  }

  goToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  onSubmit(values: any, contactValues: any ): void {
    this.client.getClient$(this.contactUUID, this.clientId).subscribe((data: {}) => {
      this.clientInfo = data;
    })

    console.log(contactValues);

    let clientInfo = {
      "client_fname": values.first_name,
      "client_lname": values.last_name,
      "client_gender": values.gender,
      "client_address": values.address,
      "client_address2": values.address2,
      "client_city": values.city,
      "client_province": values.province,
      "client_country": values.country,
      "client_postalcode": values.postalcode,
      "client_language_id": values.language,
      "client_referral_id": values.referral,
      "client_referral_note": values.referral_note,
      "client_updated": this.clientInfo.client_updated,
      "client_active": this.clientInfo.active,
    }

    this.submitClientContactInfos(contactValues);

    this.client.modifyClient$(this.contactUUID, this.clientId, clientInfo).subscribe({
      next: (data:any) => {
        this.update_message = "mise à jour effectuée";
        console.log("Success updating the client", data);
        this.clientInfo.client_updated = data.client_updated;
        this.goToTop();
        //this.router.navigate(['/clients']);
      },
      error: (err: any) => {
        console.log("Something went wrong updating the client: ", err)
        console.log("ooops", clientInfo);
      }
    })
  }

  submitClientContactInfos(info: any): void {
    this.client.modifyClientContact$(this.contactUUID, this.clientId, info).subscribe({
      next: data => {
        console.log("Success updating client contact data: ", data)
      },
      error: err => {
        console.log("Something went wrong while updating client contact data: ", err)
      }
    });
  }

}
